module.exports = __webpack_public_path__ + "assets/img/mask-bg1-long.c88f68fd.png";